import { useGLTF } from '@react-three/drei';
import { useLoader } from '@react-three/fiber';
import { memo } from 'react';
import { TextureLoader } from 'three/src/loaders/TextureLoader';

type Props = {
  pos?: Array<number>;
};

const Model = ({ pos = [0.071, -0.41, -1.642] }: Props) => {
  const { nodes } = useGLTF('/part1/part1.glb');
  // const ao = useLoader(TextureLoader, '/part1/Part1_AO.jpg');
  const diffuse = useLoader(TextureLoader, '/part1/Part1_Diffuse.jpg');
  const normal = useLoader(TextureLoader, '/part1/Part1_Normal.jpg');
  return (
    <group
      dispose={null}
      position={[pos[0], pos[1], pos[2]]}
      rotation={[0, Math.PI / 2, 0]}
    >
      <mesh
        geometry={nodes.Object001.geometry}
        rotation={[0, 0, 0]}
        scale={0.00173}
      >
        <meshStandardMaterial
          map={diffuse}
          normalMap={normal}
          roughness={0.1}
        />
      </mesh>
    </group>
  );
};

export default memo(Model);
